/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfo_shipment$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbShipping_shipment$ref: FragmentReference;
export type PdpSharedBlurbShipping_shipment = {|
  +$fragmentRefs: PdpSharedShippingInfo_shipment$ref,
  +$refType: PdpSharedBlurbShipping_shipment$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fd943ebbb247a64b160488f7e7007c7b';
module.exports = node;
